import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from "react-intl";

import Grid from "@mui/material/Grid";

import FormattedNumberWithCurrency from "components/formattedNumberWithCurrencies/formattedNumberWithCurrency";

import Detail from "./components/Detail";
import ProductName from "./components/ProductName";
import BenchmarkPrice from "./components/BenchmarkPrice";

import {blue500} from "assets/jss/main";

import store from "store";

ProductDetails.propTypes = {
    name: PropTypes.string,
    eshopId: PropTypes.string,
    sku: PropTypes.string,
    price: PropTypes.number,
    stock: PropTypes.number,
    updatedAt: PropTypes.node,
    url: PropTypes.string,
    status: PropTypes.bool,
    lastPushedAt: PropTypes.node,
    totalImages: PropTypes.number,
    firstVariation: PropTypes.object,
    benchmarkPrice: PropTypes.number,
    priceCompetitiveness: PropTypes.number
};

function ProductDetails({name, eshopId, sku, price, stock, updatedAt, lastPushedAt, url, status, firstVariation, totalImages, benchmarkPrice, priceCompetitiveness, ...props}) {
    const currentOrganization = store.getState()?.currentOrganization?.retrieved;

    return (
        <Grid container>
            <Grid item xs={12} paddingTop={3} paddingBottom={2}>
                <ProductName name={name} />
            </Grid>
            <Grid item container>
                <Detail
                    name={props.intl.formatMessage({id: 'product.show.resume.details.eshopId'})}
                    value={eshopId}
                />
                <Detail
                    name={props.intl.formatMessage({id: 'product.show.resume.details.sku'})}
                    value={sku}
                />
                {(firstVariation || price != null) && (
                    <Detail
                        name={props.intl.formatMessage({id: 'product.show.resume.details.price'})}
                        value={<FormattedNumberWithCurrency value={firstVariation?.price ?? price} currency={currentOrganization?.currency} />}
                        tooltipMessageId={'product.show.resume.details.price.tooltip'}
                    />
                )}
                {firstVariation?.outletPrice != null && (
                    <Detail
                        name={props.intl.formatMessage({id: 'product.show.resume.details.outletPrice'})}
                        value={<FormattedNumberWithCurrency value={firstVariation.outletPrice} currency={currentOrganization?.currency} />}
                        tooltipMessageId={'product.show.resume.details.outletPrice.tooltip'}
                    />
                )}
                {firstVariation?.discountedPrice && (
                    <Detail
                        name={props.intl.formatMessage({id: 'product.show.resume.details.discountedPrice'})}
                        value={<FormattedNumberWithCurrency value={firstVariation.discountedPrice} currency={currentOrganization?.currency} />}
                        tooltipMessageId={'product.show.resume.details.discountedPrice.tooltip'}
                    />
                )}
                <BenchmarkPrice
                    benchmarkPrice={benchmarkPrice}
                    priceCompetitiveness={priceCompetitiveness}
                    currency={currentOrganization?.currency}
                />
                <Detail
                    name={props.intl.formatMessage({id: 'product.show.resume.details.stock'})}
                    value={stock}
                />
                <Detail
                    name={props.intl.formatMessage({id: 'product.show.resume.details.updatedAt'})}
                    value={updatedAt}
                />
                {lastPushedAt && (
                    <Detail
                        name={props.intl.formatMessage({id: 'product.show.resume.details.lastPushedAt'})}
                        value={lastPushedAt}
                    />
                )}
                <Detail
                    name={props.intl.formatMessage({id: 'product.show.resume.details.totalImages'})}
                    value={totalImages}
                />
            </Grid>
            {url && status && (
                <Grid item xs={12} paddingTop={2}>
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            color: blue500,
                            fontSize: '14px',
                            fontWeight: 500,
                            textDecoration: 'underline',
                        }}
                    >
                        {props.intl.formatMessage({id: 'product.show.resume.details.url'})}
                    </a>
                </Grid>
            )}
        </Grid>
    );
}

export default injectIntl(ProductDetails);
